"use client";
import React from "react";
import {
  Box,
  Center,
  Separator,
  Table,
  VStack,
  Flex,
  SimpleGrid,
} from "@chakra-ui/react";
import { Heading, Text } from "@/elements";
import { useHeadingVariant } from "@/theme/hooks/useSectionStyle";
import PricingFooter from "@/components/pricingFooter";
import { BLOCK_STORAGE_DATA, TABLE_HEADER, TableFooterConstants } from "./constants";

export const DesktopView = () => {
  return (
    <Box overflowX="auto" w="100%">
      <Table.Root striped border={"2px solid rgb(237,242,247)"} width={"100%"}>
        <Table.Header>
          <Table.Row>
            <Table.ColumnHeader textAlign={"center"}>Storage</Table.ColumnHeader>
            <Table.ColumnHeader textAlign={"center"}>
              Outbound Transfer
            </Table.ColumnHeader>
            <Table.ColumnHeader textAlign={"center"}>Price / month</Table.ColumnHeader>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {BLOCK_STORAGE_DATA.map((item, index) => (
            <Table.Row key={index} fontSize={"15px"} color="#2d3748">
              <Table.Cell textAlign={"center"}>{item.storage}</Table.Cell>
              <Table.Cell textAlign={"center"}>{item.outbound}</Table.Cell>
              <Table.Cell textAlign={"center"}>
                <Text fontWeight={"700"} fontSize={"18px"} color="primary.200">
                  {item.price}
                </Text>
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table.Root>
    </Box>
  );
};

export const MobileView = () => {
  return (
    <SimpleGrid columns={2} gap={6}>
      {BLOCK_STORAGE_DATA.map((item, index) => (
        <VStack
          key={index}
          borderRadius="lg"
          borderWidth="1px"
          borderColor="gray.200"
          boxShadow="md"
          gap={4}
          w="100%"
          p={4}
          bg="white"
        >
          <Flex direction="column" align="center" w="full">
            <Box>
              <Text as="span" fontSize="lg" color="text.100">
                Storage{" "}
              </Text>
              <Text as="span" fontWeight="bold" fontSize="lg">
                {item.storage}
              </Text>
            </Box>
            <Separator borderColor="gray.200" my={2} w="60%" />
            <Text fontWeight="bold" fontSize="xl" color="primary.200">
              {item.price}/mo
            </Text>
          </Flex>
        </VStack>
      ))}
    </SimpleGrid>
  );
};

const BlockStorageTable = () => {
  const HeadingVariant = useHeadingVariant();
  return (
    <Box id="block-storage">
      <Heading variant={HeadingVariant} textAlign={"center"} mb={4}>
        {TABLE_HEADER.title}
      </Heading>
      <Text fontSize="lg" color="gray.600" textAlign="center" mb={8}>
        {TABLE_HEADER.subTitle}
      </Text>

      <Center display={{ md: "none" }} w="full" mb={4}>
        <MobileView />
      </Center>
      <Box display={{ base: "none", md: "block" }} mb={4}>
        <DesktopView />
      </Box>
      <PricingFooter {...TableFooterConstants} />
      <Separator borderWidth="2px" borderColor="#ECECEC" my={10} />
    </Box>
  );
};

export default BlockStorageTable;
